import { CONTRACT_APPRAISAL_CONTINGENCY } from '@/config/constants';

/**
 * Single source of the appraisal-contingency wording shared by the on-screen
 * contract preview and the downloadable PDF, so the two can't drift apart
 * again (the preview previously printed "is not contingent upon the Property
 * appraising for least the Purchase Price" when the buyer had *selected* that
 * contingency).
 */
export type AppraisalClauseTerms =
  | { contingent: false; statement: string }
  | { contingent: true; statement: string; requiredAmount: string };

const REQUIRED_AMOUNT: Partial<Record<string, string>> = {
  [CONTRACT_APPRAISAL_CONTINGENCY.AT_LEAST_PURCHASE_PRICE]:
    'the Purchase Price',
  [CONTRACT_APPRAISAL_CONTINGENCY.AT_LEAST_LISTING_PRICE]: 'the Listing Price',
  [CONTRACT_APPRAISAL_CONTINGENCY.AT_LEST_WITHIN_RANGE]:
    "the Purchase Price less Buyer's down payment",
};

export const NO_APPRAISAL_CONTINGENCY_TEXT =
  'This Contract is not contingent upon the Property appraising for any specific amount.';

export function getAppraisalClauseTerms(
  appraisalContingency?: string | null
): AppraisalClauseTerms {
  const requiredAmount = appraisalContingency
    ? REQUIRED_AMOUNT[appraisalContingency]
    : undefined;
  if (!requiredAmount) {
    return { contingent: false, statement: NO_APPRAISAL_CONTINGENCY_TEXT };
  }
  return {
    contingent: true,
    requiredAmount,
    statement: `This Contract is contingent upon the Property appraising for at least ${requiredAmount}.`,
  };
}
